import { create } from 'zustand';
import { getBrandConfig, type BrandConfig } from '../api/brand';

// ============================================================
// H2：平台品牌（白标 OEM）
// initBrand()：启动时拉取 GET /brand/config，写入 store 并应用 document.title/favicon
// 与 oemStore（按项目发布令牌的 OEM）相互独立：品牌为平台级、OEM 为项目级
// ============================================================
interface BrandState {
  config: BrandConfig | null;
  loaded: boolean;
  setConfig: (config: BrandConfig | null) => void;
}

export const useBrandStore = create<BrandState>((set) => ({
  config: null,
  loaded: false,
  setConfig: (config) => set({ config, loaded: true }),
}));

export function applyBrandDom(config: BrandConfig | null): void {
  if (!config || config.enabled === false || typeof document === 'undefined') return;
  if (config.name) document.title = config.name;
  if (config.faviconUrl) {
    let link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = config.faviconUrl;
  }
  if (config.primaryColor) {
    document.documentElement.style.setProperty('--brand-primary', config.primaryColor);
  }
}

let inflight: Promise<void> | null = null;

export function initBrand(): Promise<void> {
  if (inflight) return inflight;
  inflight = getBrandConfig()
    .then((config) => {
      useBrandStore.getState().setConfig(config);
      applyBrandDom(config);
    })
    .catch(() => {
      useBrandStore.getState().setConfig(null);
    });
  return inflight;
}
